import {useDispatch, useSelector} from "react-redux";
import React, {useRef, useState} from "react";
import classNames from "classnames";
import {appendSupportChatMessages, appendSupportChatSession, setSupportChatSessionId} from "../../../actions";
import AjaxButton from "../../../../form/ajax_button";

const NewChatWindow = (props) => {
  const dispatch = useDispatch()

  const sendButton = useRef(null);
  const [currentMessage, setCurrentMessage] = useState("")
  const clientNewSessionSendSupportChatMessageUrl = useSelector((state) => state.clientSendSupportChatMessageUrl)
  const translations = useSelector(state => (state.htmlContents || []).find(hc => hc.identifier == "support_chat.translations")?.json || {})

  const handleChatInput = (event) => {
    if (event.key === 'Enter' && !event.shiftKey && sendButton.current && event.target.value) {
      event.preventDefault()
      event.stopPropagation()
      sendButton.current.click()
    }
  }

  return <div className="row no-gutters chat-window">
    <div className="col-12 text-center">
      <br/>
      {/*<h4>Start a new Chat</h4>*/}
      {/*<p>To start chatting with us just send a message.</p>*/}
      {/*<br/>*/}
    </div>
    <div className="col-12">
      <div className="input-group chat-window-input-form-group">
        <input
          className="form-control"
          type="text"
          onKeyDown={handleChatInput}
          placeholder={translations?.write_your_message || "Write your message"}
          value={currentMessage}
          onChange={(event) => {
            setCurrentMessage(event.target.value)
          }}
        />
        {currentMessage ? <div className="input-group-append">
          <AjaxButton
            buttonRef={sendButton}
            method="post"
            labelSending={translations?.sending || "Sending ..."}
            className={classNames("btn btn-outline-success btn-ueg btn-ueg-styled")}
            icon="fa-save"
            url={clientNewSessionSendSupportChatMessageUrl}
            data={{image_map_id: props.imageMap.id, body: currentMessage}}
            label={translations?.send || "Send"}
            onSuccess={(data) => {
              if (data.data.status === "OK") {
                setCurrentMessage("")
                props.onSuccessfullySent ? props.onSuccessfullySent() : null
                dispatch(appendSupportChatSession(data.data.support_chat_session))
                dispatch(appendSupportChatMessages(data.data.support_chat_messages))
                dispatch(setSupportChatSessionId(data.data.support_chat_session.id))
              } else {
                alert(data.data.message || "A error occurred sending the message.")
              }
            }}
            onError={(error) => {
              console.log(error)
              alert("Error sending chat message", error)
            }}
          />
        </div> : null}
      </div>
    </div>
  </div>;
}

export default NewChatWindow;